import { defaultEnumFilter } from '@/components/table-filters/constants';
import type {
  Filter,
  FilterEnumChoice,
} from '@/components/table-filters/constants';

export const VACANCY_CONTRACT_STATUS_FILTER: FilterEnumChoice[] = [
  {
    filters: [{ operator: 'noop', value: 'active' }],
    title: 'Aktiv',
    id: 'active',
    badgeVariant: 'green',
    overrideExternalFieldName: 'custom_vacancy_contract_status_filter',
  },
  {
    filters: [{ operator: 'noop', value: 'earlier' }],
    title: 'Tidigare',
    id: 'earlier',
    badgeVariant: 'gray',
    overrideExternalFieldName: 'custom_vacancy_contract_status_filter',
  },
  {
    filters: [{ operator: 'noop', value: 'upcoming' }],
    title: 'Kommande',
    id: 'upcoming',
    badgeVariant: 'blue',
    overrideExternalFieldName: 'custom_vacancy_contract_status_filter',
  },
];

export const defaultVacancyContractStatusFilter: Filter[] = [
  {
    ...defaultEnumFilter,
    title: 'Status',
    externalFieldName: 'custom_vacancy_contract_status_filter',
    enumChoices: VACANCY_CONTRACT_STATUS_FILTER,
  },
];
